import { gql } from '@apollo/client'

export const BRAND_SOVI_PIE_CHART = gql`
  query BrandSoviPieChart($input: DXOExecutionForZonePathInput!) {
    brandSoviPieChart(input: $input) {
      label
      value
    }
  }
`
